<template>
  <div>
    <div v-for="mode in allModes" :key="mode" class="radio">
      <label :for="`mode_${mode}`">
        <input
          type="radio"
          :id="`mode_${mode}`"
          name="mode"
          :value="mode"
          :checked="selectedMode === mode"
          :disabled="!isAvailable(mode)"
          @change="$emit('selected', mode)"
        />
        <div :class="{ disabled: !isAvailable(mode) }">
          {{ lang.get('score-set.modes.' + mode) }}
          <help-icon
            v-if="!isAvailable(mode)"
            :content="lang.get('features.not_available')"
          />
        </div>
      </label>
      <p :class="{ 'radio-description': true, disabled: !isAvailable(mode) }">
        {{ lang.get(`panels.modes.${mode}.description`) }}
      </p>
    </div>
  </div>
</template>

<script>
import HelpIcon from '@/lib/components/Shared/HelpIcon';

export default {
  inject: ['lang'],
  components: {
    HelpIcon
  },
  props: {
    allModes: {
      type: Array,
      required: true
    },
    availableModes: {
      type: Array,
      required: true
    },
    selectedMode: {
      type: String,
      default: ''
    }
  },
  methods: {
    isAvailable(mode) {
      return this.availableModes.includes(mode);
    }
  }
};
</script>
